module.exports = __webpack_public_path__ + "static/media/2.9.39aa702a.pdf";